import { render, staticRenderFns } from "./BiographyEditDialog.vue?vue&type=template&id=2fa4fd42&"
import script from "./BiographyEditDialog.vue?vue&type=script&lang=js&"
export * from "./BiographyEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports